import ApiBaseService from './ApiBaseService';

class AuthService {

    static login(data) {
        return ApiBaseService.request('/api/auth/signin', 'POST', data);
    }

    static verifyOtp(data) {
        return ApiBaseService.request('/api/auth/signin-otp', 'POST', data);
    }

    static register(data) {
        return ApiBaseService.request('/api/auth/signup', 'POST', data);
    }

    static verifyUser(data) {
        return ApiBaseService.request('/api/auth/verify', 'POST', data);
    }

    // * Data - { email }
    static forgotPassword(data) {
        return ApiBaseService.request('/api/auth/forgotpwd', 'POST', data);
    }

    // * Data - { token }
    static passwordToken(data) {
        return ApiBaseService.request('/api/auth/pwdtoken', 'POST', data);
    }

    // * Data - { token, password }
    static resetPassword(data) {
        return ApiBaseService.request('/api/auth/resetpwd', 'POST', data);
    }

    static refresh() {
        return ApiBaseService.request('/api/auth/refresh', 'POST');
    }
    static fcmToken([data]) {
        return ApiBaseService.request('/api/auth/fcmtoken', 'POST', data);
    }
}

export default AuthService;